module.exports = __webpack_public_path__ + "public/images/stands-right-bg.79e8a557c4f6d039ad8c4124732d1dea.svg";